import Loading from 'Body/Statuses/Loading';
import React, { useEffect, useState, useContext } from 'react';
import { useAuth0 } from '../../../../../auth0/reactAuth0Spa';
import { DepartmentContext } from '../../../../../DepartmentWrapper';
import { checkLoginForError, formatBearerToken } from '../../../../../Common.functions';
import { fetchDataAgnostic } from '../../../../../Services/dataApi';
import AdminEmailPreview from './AdminEmailPreview/AdminEmailPreview';
import AdminSentItems from './AdminSentItems/AdminSentItems';
import RezRateSideDrawer from 'Body/RezRATE/Common/RezRateSideDrawer/RezRateSideDrawer';
import './AdminCommunicationHistoryLanding.style.css';

const AdminCommunicationHistoryLanding = ({ activeDepartment, windowWidth }) => {
  const [selectedSentItem, setSelectedSentItem] = useState();
  const [sentMessages, setSentMessages] = useState([]);
  const [isLoadingSentMessages, setIsLoadingSentMessages] = useState(false);
  const [templateWrapperHtml, setTemplateWrapperHtml] = useState('');

  const [drawerOpen, setDrawerOpen] = useState(false);
  const { getTokenSilently, loginWithRedirect } = useAuth0();
  const dContext = useContext(DepartmentContext);
  const { department, season } = dContext;
  const widthToSwitchToMobile = 900;

  useEffect(() => {
    if (department && season) {
      getSentMessages();
      getTemplateWrapper();
    }
  }, [department, season]);

  const getSentMessages = () => {
    if (!activeDepartment || activeDepartment.pk_Department === null || activeDepartment.pk_Department === undefined) {
      return;
    }
    setIsLoadingSentMessages(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/communication/history',
          { pk_Department: department.pk_Department, pk_Season: season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            setIsLoadingSentMessages(false);
            setSentMessages(res.data);
          })
          .catch((err) => {
            setIsLoadingSentMessages(false);
          });
      })
      .catch((err) => {
        console.log('getSentMessages getToken err: ', err);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getTemplateWrapper = () => {
    if (!activeDepartment || activeDepartment.pk_Department === null || activeDepartment.pk_Department === undefined) {
      return;
    }

    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/template/wrapper',
          { pk_Department: department.pk_Department, pk_Season: season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            setTemplateWrapperHtml((res && res.data && res.data.Wrapper) || '');
          })
          .catch(() => {
            setTemplateWrapperHtml('');
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  if (department === null || department === undefined) {
    return <div />;
  }

  if (windowWidth < widthToSwitchToMobile) {
    // Mobile: SentItems in drawer, preview fills space
    return (
      <div className="comm-history-mobile">
        <RezRateSideDrawer isOpen={drawerOpen} setIsOpen={setDrawerOpen} options={{ width: 350 }}>
          <div className="comm-history-mobile-drawer">
            <AdminSentItems
              isFetchingItems={isLoadingSentMessages}
              activeDepartment={activeDepartment}
              selectedSentItem={selectedSentItem}
              setSelectedSentItem={(item) => {
                setSelectedSentItem(item);
                setDrawerOpen(false);
              }}
              sentMessages={sentMessages}
              isDark={true}
            />
          </div>
        </RezRateSideDrawer>
        <div className="comm-history-panel comm-history-panel--preview comm-history-panel--mobile">
          {isLoadingSentMessages ? (
            <div className="comm-history-loading-wrap">
            <Loading options={{ labelText: 'Loading Messages. . .' }} />
          </div>
        ) : (
            <AdminEmailPreview itemToPreview={selectedSentItem} wrapperHtml={templateWrapperHtml} />
          )}
        </div>
      </div>
    );
  }

  // Desktop: original layout
  return (
    <div className="comm-history-layout">
      <div className="comm-history-panel comm-history-panel--list">
        <AdminSentItems
          isFetchingItems={isLoadingSentMessages}
          activeDepartment={activeDepartment}
          selectedSentItem={selectedSentItem}
          setSelectedSentItem={setSelectedSentItem}
          sentMessages={sentMessages}
        />
      </div>
      <div className="comm-history-panel comm-history-panel--preview">
        {isLoadingSentMessages ? (
          <div className="comm-history-loading-wrap">
            <Loading options={{ labelText: 'Loading Messages. . .' }} />
          </div>
        ) : (
          <AdminEmailPreview itemToPreview={selectedSentItem} wrapperHtml={templateWrapperHtml} />
        )}
      </div>
    </div>
  );
};

export default AdminCommunicationHistoryLanding;
